import React from 'react';
import { withHydrator } from '@thd-olt-component-react/hydrator';
import { withDynamicComponent, withDynamicImport } from '@thd-nucleus/app-render';
import { withErrorBoundary } from '@thd-olt-component-react/error-boundary';
import { defaultProps, propTypes } from './fbr.util';
import { FBRPlaceholder } from './FBRPlaceholder/FBRPlaceholder';
import { dataModel } from './dataModel';

const placeholder = (
  <FBRPlaceholder
    color="#E0E0E0"
    showLoadingAnimation
  />
);

const ImportedComponent = withDynamicImport({
  server: () => {
    // For webpack environments only
    if (typeof __webpack_require__ !== 'undefined') {
      return __webpack_require__(require.resolveWeak('./FeatureBasedRecommendations.component')).FeatureBasedRecommendations;
    }
    // Non-webpack environments should use FeatureBasedRecommendationsImporter.vite
    return null;
  },
  client: () => {
    return import(
      /* webpackPrefetch: true, webpackChunkName: "fbr" */
      './FeatureBasedRecommendations.component');
  },
  placeholder,
  name: 'FeatureBasedRecommendations',
});

const HydratedComponent = withHydrator({
  delay: 1500,
  id: 'product-section-fbr',
  placeholder,
  preserveCtxVal: 'clientStore',
  scrollBuffer: 750,
}, ImportedComponent);

const DynamicComponent = withDynamicComponent(HydratedComponent,
  { placeholder }
);

const fbrdataModel = dataModel;

export const FeatureBasedRecommendationsImporter = withErrorBoundary(DynamicComponent);

FeatureBasedRecommendationsImporter.displayName = 'FeatureBasedRecommendationsImporter';
FeatureBasedRecommendationsImporter.propTypes = propTypes;
FeatureBasedRecommendationsImporter.defaultProps = defaultProps;
FeatureBasedRecommendationsImporter.dataModel = fbrdataModel;
